// /**
//  *
//  * @param departDate {Date}
//  * @param returnDate {Date?}
//  * @param singleTripCost {Number}
//  * @return number
//  */
// export function calculateTripCost(departDate, returnDate, singleTripCost) {
//   const format = "HH:mm"
//   console.log("departDate?=?=", departDate)
//
//   let tripCost = singleTripCost
//   let departDateMoment = this.$moment(departDate)
//   let returnDateMoment = returnDate ? this.$moment(returnDate) : null
//
//   const afterTime = this.$moment("19:00", format),
//       beforeTime = this.$moment("07:00", format)
//   // console.log("time now????", this.$moment().toDate())
//   console.log("departTime ==", departDateMoment.format("dd MM yyyy HH:mm:ss"))
//   // console.log("beforeTime", beforeTime.format('dd MM yyyy HH:mm:ss'))
//   // // console.log("afterTime", afterTime.format('dd MM yyyy HH:mm'))
//   // console.log("departTime isBetween?", departTime > beforeTime)
//
//   if(departDateMoment.hour() >=  afterTime.hour() || departDateMoment.hour() < beforeTime.hour()){
//     tripCost = tripCost + getPercentage(singleTripCost, 15)
//   }
//
//   if(returnDateMoment) {
//     if(returnDateMoment.hour() >=  afterTime.hour() || returnDateMoment.hour() < beforeTime.hour()){
//       tripCost += getPercentage(singleTripCost, 15)
//     }
//
//     tripCost += singleTripCost
//
//   }
//
//
//   // console.log("returnTime", returnTime)
//
//   return Math.round(tripCost)
//
//
//
// }

exports.getPercentage = (num, per) =>
{
  return (num/100)*per
}

// /**
//  *
//  * @param date {FirebaseFirestore.Timestamp| Date | String }
//  * @returns {moment.Moment} for checking use moment.isValid()
//  */
// exports.getMomentDate = (date = new Date()) => {
//   if (date instanceof admin.firestore.Timestamp) {
//     return this.$moment(date.toDate())
//   } else if (date instanceof Date) {
//     return this.$moment(date)
//   } else
//     return this.$moment(date) //`returns invalid Moment object`
// }

exports.getStatusClass = (val) => {
  // type (primary|info|danger|default|warning|success)
  console.log(val)
  switch (val) {
    case "verified":
      return "bg-warning"
    case "active":
    case "REFUNDED":
    case "PAID":
      return "bg-gradient-green"
    case "pending":
    case "pending_payment":
      return "bg-warning"
    case "purchased":
      return "bg-success"
    case "canceled_abandoned":
      return "bg-black"
    case "finished":
      return "bg-secondary"
    default:
      return "bg-danger"
  }
}

exports.toCents = (val) => {
  return parseFloat(val).toFixed(2) * 100
}

exports.countDecimals = (val) => {
  if(Math.floor(this.valueOf()) === this.valueOf()) return 0
  return this.toString().split(".")[1].length || 0
}

exports.isoCountryCodeToFlagEmoji = (country) => {
  return String.fromCodePoint(...[...country.toUpperCase()].map(c => c.charCodeAt() + 0x1F1A5))
}

exports.isWindows = navigator.platform.indexOf("Win") > -1


exports.getDuration = (start, end) => {

  // Add one day if end is before start
  if (end.isBefore(start)) {
    end.add(1, "day")  // Add 24 hours to the end time
  }

  // Calculate the difference in minutes
  const difMinutes = end.diff(start, "minutes", true)

  // If difference is more than 60 minutes, convert to hours and minutes
  if (difMinutes >= 60) {
    const hours = Math.floor(difMinutes / 60)
    const minutes = Math.floor(difMinutes % 60)
    return hours + "h" + (minutes > 0 ? minutes + " m" : "")
  }

  // Otherwise return the minutes
  return Math.floor(difMinutes) + "m"
}

exports.normalizeGreek = (text) => {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

exports.getTranslation = (translation, locale) => {
  if (Object.hasOwn(translation, "el") && translation.el !== "" && translation.el !== null && locale === "el"){
    return translation.el
  } else if (Object.hasOwn(translation, "en") && translation.en !== "" && translation.en !== null){
      return translation.en
  } else {
    return translation
  }
}

exports.removeIntonations = function (text) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

exports.mimeTypeToExtensionMap = function (mimeType){
  const types = {
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/pjpeg": ".jpg", // just in case
    "image/svg+xml": ".svg",
    "image/webp": ".webp",
    "application/pdf": ".pdf",
    "application/msword": ".doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
    "text/csv": ".csv",
    "application/vnd.ms-excel": ".xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
    "application/vnd.oasis.opendocument.spreadsheet": ".ods",
    "application/vnd.apple.pages": ".pages"
  }
  return types[mimeType] || ""
}